module.exports = __webpack_public_path__ + "static/media/iconfinder_property-agent-005_1851811.d29343b4.svg";